import axios from 'axios';

export default axios.create({
    baseURL: 'https://entreprise.data.gouv.fr/api/sirene/v3',
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    },
});